import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { resources } from "@/mocks/ppcare";

export default function ResourcesSection() {
  return (
    <section id="resources" className="bg-background-100 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="Our Resources"
            title={
              <>
                Personal Physician Care{" "}
                <span className="text-accent-500">Resources</span>
              </>
            }
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-7 md:grid-cols-3">
          {resources.map((resource, index) => (
            <Reveal key={resource.title} delay={index * 100}>
              <div className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="h-52 overflow-hidden">
                  <img
                    src={resource.image}
                    alt={resource.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="text-lg font-bold text-foreground-900">{resource.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                    {resource.text}
                  </p>
                  <a
                    href={resource.ctaHref}
                    className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    {resource.ctaLabel}
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}